import styled from 'styled-components';

export const ChartTitleRoot = styled.div`
  display: flex;
  flex: 1;
`;
